import {Component, EventEmitter, OnDestroy, OnInit, Output, signal} from "@angular/core";
import {Subscription} from "rxjs";
import {
  ParametrageFacturationHierarchy
} from "../../../../core/models/facturation/client/parametrage-facturation-hierarchy";
import {NamedItem} from "../../../../core/models/named-item";
import {FacturationClientService} from "../../../../core/services/entities/facturation-client.service";
import {UtilsService} from "../../../../core/utils/utils.service";
import {
  FilterExportAnalyseFinanciere
} from "../../../../core/models/facturation/client/filter-export-analyse-financiere";
import {saveAs} from "file-saver";
import {TypeExportAnalyseFinanciere} from "../../../../core/enums/facturation/client/type-export-analyse-financiere";
import {AnalyseFinanciere} from "../../../../core/models/facturation/client/analyse-financiere";
import {ButtonThemeEnum} from "../../../../shared/ui/button/button-theme-enum";

@Component({
    selector: 'yo-analyse-financiere-export',
    templateUrl: './analyse-financiere-export.component.html',
    styleUrls: ['./analyse-financiere-export.component.scss'],
    standalone: false
})

export class AnalyseFinanciereExportComponent implements OnInit, OnDestroy {

  public readonly ButtonThemeEnum = ButtonThemeEnum;

  typeExport = TypeExportAnalyseFinanciere;
  subHierarchy: Subscription;
  subHierarchiePlat: Subscription;
  subOpenDialog: Subscription;
  selectedPeriode: Date[] = [new Date(), new Date()];
  public cellTypes = AddZoneProperty;

  public hierarchy: ParametrageFacturationHierarchy;
  public hierarchyPlat: ParametrageFacturationHierarchy;

  public offreAlimentaireList: NamedItem[] = [];
  public prestationList: NamedItem[] = [];
  public repasList: NamedItem[] = [];
  public regimeList: NamedItem[] = [];
  public uniteProductionList = signal<NamedItem[]>([]);
  public pointFacturationList: NamedItem[] = [];
  public pointLivraisonList: NamedItem[] = [];

  public selectedOffreAlimentaireList: number[] = [];
  public selectedRepasList: number[] = [];
  public selectedRegimeList: number[] = [];
  public selectedUniteProductionList: number[] = [];
  public selectedPointFacturationList: number[] = [];
  public selectedPointLivraisonList: number[] = [];
  public selectedPrestationList: number[] = [];
  displayDialog: boolean = false;
  selectedTab: TypeExportAnalyseFinanciere = TypeExportAnalyseFinanciere.PRESTATION;
  selectedTabIndex = signal<number>(0);
  @Output() currentIndexChange: EventEmitter<number> = new EventEmitter<number>();


  constructor(private facturationClientSvc: FacturationClientService,
              private utilsSvc: UtilsService) {
  }

  ngOnInit(): void {
    this.initHierarchy();
    this.initHierarchiePlat();
    this.subDialog();
  }

  ngOnDestroy(): void {
    this.utilsSvc.unsubscribe(this.subHierarchy);
    this.utilsSvc.unsubscribe(this.subHierarchiePlat);
    this.utilsSvc.unsubscribe(this.subOpenDialog);
  }


  private initHierarchy() {
    this.subHierarchy = this.facturationClientSvc.findLigneParametrageHierarchy().subscribe(result => {
      if (result) {
        this.hierarchy = result.one;
        this.uniteProductionList.set(this.hierarchy.unitesProduction);
        this.updateValuePrestation([], AddZoneProperty.UNITE_PRODUCTION);
      }
    });
  }

  private initHierarchiePlat() {
    this.subHierarchiePlat = this.facturationClientSvc.findLigneExportPlatHierarchy().subscribe(result => {
      if (result) {
        this.hierarchyPlat = result.one;
      }
    });
  }


  /**
   * Permet de mettre à jour la valeur et de réinitialiser les propriétés suivantes
   */
  updateValuePrestation = (value: number[], property: AddZoneProperty) => {
    switch (property) {
      case AddZoneProperty.UNITE_PRODUCTION:
        this.selectedUniteProductionList = value;
        this.pointFacturationList = this.initProperty(this.selectedUniteProductionList, this.hierarchy.pointsFacturationByUniteProductionId);
        value = [];
      // pas de break
      case AddZoneProperty.POINT_FACTURATION:
        this.selectedPointFacturationList = value;
        this.pointLivraisonList = this.initProperty(this.selectedPointFacturationList, this.hierarchy.pointsLivraisonByPointFacturationId);
        value = [];
      // pas de break
      case AddZoneProperty.POINT_LIVRAISON:
        this.selectedPointLivraisonList = value;
        this.offreAlimentaireList = this.initProperty(this.selectedPointLivraisonList, this.hierarchy.offresAlimentaireByPointLivraison);
        value = [];
      // pas de break
      case AddZoneProperty.OFFRE_ALIMENTAIRE:
        this.selectedOffreAlimentaireList = value;
        this.prestationList = this.initProperty(this.selectedOffreAlimentaireList, this.hierarchy.prestationsByOffreAlimentaireId);
        value = [];
      // Pas de break
      case AddZoneProperty.PRESTATION:
        this.selectedPrestationList = value;
        this.repasList = this.initProperty(this.selectedPrestationList, this.hierarchy.repasByPrestationId);
        this.regimeList = this.initProperty(this.selectedPrestationList, this.hierarchy.regimesByPrestationId);
        this.selectedRegimeList = [];
        value = [];
      // Pas de break
      case AddZoneProperty.REPAS:
        this.selectedRepasList = value;
        break;
      case AddZoneProperty.REGIME:
        this.selectedRegimeList = value;
        break;
    }
  }

  updateValuePlat = (value: number[], property: AddZoneProperty) => {
    switch (property) {
      case AddZoneProperty.UNITE_PRODUCTION:
        this.selectedUniteProductionList = value;
        this.pointLivraisonList = this.initProperty(this.selectedUniteProductionList, this.hierarchyPlat.pointsLivraisonByUniteProductionId);
        value = [];
      // pas de break
      case AddZoneProperty.POINT_LIVRAISON:
        this.selectedPointLivraisonList = value;
        this.offreAlimentaireList = this.initProperty(this.selectedPointLivraisonList, this.hierarchyPlat.offresAlimentaireByPointLivraison);
        value = [];
      case AddZoneProperty.OFFRE_ALIMENTAIRE:
        this.selectedOffreAlimentaireList = value;
        this.prestationList = this.initProperty(this.selectedOffreAlimentaireList, this.hierarchyPlat.prestationsByOffreAlimentaireId);
        value = [];
      // Pas de break
      case AddZoneProperty.PRESTATION:
        this.selectedPrestationList = value;
        this.repasList = this.initProperty(this.selectedPrestationList, this.hierarchyPlat.repasByPrestationId);
        this.regimeList = this.initProperty(this.selectedPrestationList, this.hierarchyPlat.regimesByPrestationId);
        this.selectedRegimeList = [];
        value = [];
      // Pas de break
      case AddZoneProperty.REPAS:
        this.selectedRepasList = value;
        break;
      case AddZoneProperty.REGIME:
        this.selectedRegimeList = value;
        break;
    }
  }


  private initProperty(selected: number[], source: Map<number, NamedItem[]>) {
    let properties: NamedItem[] = [];
    if (selected?.length > 0) {
      let propertyLists: NamedItem[][] = [];
      selected.forEach(element => {
          propertyLists.push(source[element]);
      });

      let propertyIds: number[] = [];
      (propertyLists as any).flatMap(i => i).forEach(item => {
        if (!propertyIds.includes(item.id)) {
          properties.push(item);
          propertyIds.push(item.id);
        }
      });
    }

    return properties;
  }

  isParentSelected(selectedList: number[]) {
    return selectedList?.length > 0;
  }

  private subDialog() {
    this.subOpenDialog = this.facturationClientSvc.openExportSettings$.subscribe((currentIndex: number): void => {
      this.displayDialog = true;
      this.initFromSelectedTab(currentIndex);
    });
  }

  closeDialog() {
    this.displayDialog = false;
  }

  export(typeExport: TypeExportAnalyseFinanciere) {
    const filter = new FilterExportAnalyseFinanciere();
    filter.dateDebut = this.selectedPeriode[0];
    filter.dateFin = this.selectedPeriode[1];
    filter.idsUniteDeProduction = this.selectedUniteProductionList;
    filter.idsRegime = this.selectedRegimeList;
    filter.idsPointDeLivraison = this.selectedPointLivraisonList;
    filter.idsPointDeFacturation = this.selectedPointFacturationList;
    filter.idsPrestation = this.selectedPrestationList;
    filter.idsRepas = this.selectedRepasList;
    filter.type = typeExport;
    this.facturationClientSvc.exportAnalyseFinanciere(filter).subscribe((response: any) => {
      const byteCharacters = atob(response.excel);
      const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], {type: 'application/vnd.ms-excel'});
      let filename: string;
      switch (typeExport) {
        case TypeExportAnalyseFinanciere.PRESTATION:
          filename = `analyse-financiere-prestation-${new Date().getTime()}.xlsx`;
          break;
        case TypeExportAnalyseFinanciere.PLAT:
          filename = `analyse-financiere-plat-${new Date().getTime()}.xlsx`;
          break;
        case TypeExportAnalyseFinanciere.FAMILLE_PRODUIT:
          filename = `analyse-financiere-famille-produit-${new Date().getTime()}.xlsx`;
          break;
      }
      saveAs(blob, filename);
      const analyseFinanciere : AnalyseFinanciere = {details: response.data, type: typeExport}
      this.facturationClientSvc.announceExportAnalyseFinancier(analyseFinanciere);
      this.closeDialog();
    });
  }

  onDateFilterValueChange(data: any) {
    this.selectedPeriode = [data[0], data[1]];
  }

  tabChange($event: any) {
    if (this.selectedTab != $event.itemIndex) {
      this.selectedUniteProductionList = [];
      this.selectedOffreAlimentaireList = [];
      this.selectedPrestationList = [];
      this.selectedRepasList = [];
      this.selectedRegimeList = [];
      this.selectedPointFacturationList = [];
      this.selectedPointLivraisonList = [];
    }

    this.initFromSelectedTab($event.itemIndex);
    this.currentIndexChange.emit($event.itemIndex);
  }

  initFromSelectedTab(index: number) {
    this.selectedTabIndex.set(index);
    switch (index) {
      case 0:
        this.selectedTab = TypeExportAnalyseFinanciere.PRESTATION;
        this.uniteProductionList.set(this.hierarchy.unitesProduction);
        this.updateValuePrestation([], AddZoneProperty.UNITE_PRODUCTION);
        break;
      case 1:
        this.selectedTab = TypeExportAnalyseFinanciere.FAMILLE_PRODUIT;
        this.uniteProductionList.set(this.hierarchy.unitesProduction);
        this.updateValuePrestation([], AddZoneProperty.UNITE_PRODUCTION);
        break;
      case 2:
        this.selectedTab = TypeExportAnalyseFinanciere.PLAT;
        this.uniteProductionList.set(this.hierarchyPlat.unitesProduction);
        this.updateValuePlat([], AddZoneProperty.UNITE_PRODUCTION);
        break;
    }
  }
}

export enum AddZoneProperty {
  OFFRE_ALIMENTAIRE,
  PRESTATION,
  REPAS,
  REGIME,
  POINT_FACTURATION,
  POINT_LIVRAISON,
  UNITE_PRODUCTION
}
